import React from 'react';

import EventDispatcherModule from '@shcc/modules/EventDispatcherModule';

// Helpers
import bindAll from '@shcc/utils/helpers/bindAll';

class RegionComponent extends React.Component {
  state = {
    history: [],
    fragments: [],
  };

  constructor() {
    super();

    bindAll(this, ['_showCompleteHandler']);

    this._cached = {};
  }

  componentDidMount() {
    const { children } = this.props;
    this.show(children);
  }

  componentDidUpdate() {
    const { children } = this.props;
    this.show(children);
  }

  render() {
    const { fragments } = this.state;
    const { getRegion, dispatch } = this.props;

    return fragments.map(fragment => {
      const props = {
        ...fragment.props,
        getRegion,
        dispatch,
        key: fragment.key,
      };
      return React.cloneElement(fragment.element, props);
    });
  }

  // prettier-ignore
  show(element, props) {
    // Only show when configured in class
    if (element && element.type) {
      const history = [...this.state.history];
      const fragments = [...this.state.fragments];
      const key = element.type.fragment;

      // Setup fragment
      const fragment = {};
      fragment.key = key;
      fragment.element = element;

      // Setup fragment props
      fragment.props = props || {};
      fragment.props.deferredUnmount = () => this.remove(key);
      fragment.props.registerTransitionIn = callback => this.registerFragmentEvent(fragment, 'transitionIn', callback);
      fragment.props.registerTransitionOut = callback => this.registerFragmentEvent(fragment, 'transitionOut', callback);
      fragment.props.getTransitionData = () => ({
        previous: this.state.history[this.state.history.length - 2],
        current: this.state.history[this.state.history.length - 1],
      });

      if (history[history.length - 1] !== key) {
        history.push(key);
        fragments.push(fragment);

        this.setState({ history, fragments }, this._showCompleteHandler);
      }
    }
  }

  clear() {
    const { fragments } = this.state;
    const limit = fragments.length;

    let index;
    let fragment;

    for (index = 0; index < limit; index++) {
      fragment = fragments[index];

      this.envokeFragmentEvent(fragment, 'transitionOut', {
        onComplete: fragment.props.deferredUnmount,
      });

      // If there is no transition out just remove the view
      if (fragment && (!fragment.events || !fragment.events.transitionOut)) {
        this.remove(fragment.key);
      }
    }
  }

  remove(key) {
    const history = [...this.state.history];
    const fragments = [...this.state.fragments];
    const index = history.indexOf(key);

    history.splice(index, 1);
    fragments.splice(index, 1);

    this.setState({ history, fragments });
  }

  registerFragmentEvent(fragment, name, callback) {
    if (!fragment.events) {
      fragment.events = {};
    }

    fragment.events[name] = callback;
  }

  envokeFragmentEvent(fragment, name, payload = {}) {
    const event = fragment.events ? fragment.events[name] : null;

    if (event && typeof event === 'function') {
      event.call(fragment.element, payload);
    }
  }

  /**
   *
   * Handlers
   */
  // prettier-ignore
  _showCompleteHandler() {
    const { fragments, history } = this.state;
    const previous = fragments[fragments.length - 2];
    const current = fragments[fragments.length - 1];

    if (previous) this.envokeFragmentEvent(previous, 'transitionOut', { history });
    if (current) this.envokeFragmentEvent(current, 'transitionIn', { history });

    // If there is no transition out just remove the view
    if (previous && (!previous.events || !previous.events.transitionOut)) {
      this.remove(previous.key);
    }
  }
}

export default RegionComponent;
